module.exports = __webpack_public_path__ + "images/emoji/alarm_clock.50dd9fb2842594715246.png";